<template>
	<div
		v-if="!(title===undefined || description===undefined || isFirstPage===undefined || isLastPage===undefined || currentPageIsAll===undefined)"
		:id="activeSurveyId"
		:class="props.class"
		class="sd-root-modern sd-root-modern--full-container overflow-hidden">
		<div class="sd-container-modern">
			<div v-show="useTitle" class="sd-title sd-container-modern__title">
				<div class="sd-header__text">
					<h3 class="sd-title" aria-label="Assessment for the Woodland Walk">
						<div class="sv-vue-title-additional-div">
							<span class="sv-string-viewer">{{ title }}</span>
						</div>
					</h3>
					<h5 class="sd-description">
						<span class="sv-string-viewer">
							{{ description }}
							<br>
							Asterisks (*) denote required questions.
						</span>
					</h5>
					<span v-if="!isShowingPreview" class="sd-description">
						<span v-if="!isValid" style="color: rgb( var(--bs-danger-rgb));"><i
							class="bi-x-square me-2" />Survey
							incomplete</span>
						<span v-else style="color: rgb(var(--bs-success-rgb));"><i class="bi-check-square me-2" />Survey
							complete</span>
					</span>

					<span v-else class="sd-description">
						<span v-if="!valid_at_summary" style="color: rgb( var(--bs-danger-rgb));"><i
							class="bi-x-square me-2" />Survey
							incomplete</span>
						<span v-else style="color: rgb(var(--bs-success-rgb));"><i class="bi-check-square me-2" />Survey
							complete</span>
						<br>
						<span class="sv-string-viewer">
							<span class="sd-descriptionviewer">{{ completedHtml }}</span>
						</span>
					</span>
				</div>
				<div class="sd-hidden" />
			</div>

			<div
				class="navigation-block"
				style="background-color:var(--sjs-general-backcolor-dim, var(--background-dim, #f3f3f3));margin-top:2px;">
				<div class="sd-container-modern">
					<div class="sv-components-row">
						<div :id="activeSurveyId + '_sp_141'" class="sd-body sd-body--responsive py-2 px-4">
							<div class="sv-components-column">
								<h3 v-if="isPreview" class="bf sd-title py-2 mb-0">
									<div v-if="useTitle" class="sv-vue-title-additional-div">
										<span class="sv-string-viewer text-muted">Survey Summary</span>
									</div>
								</h3>
								<div
									v-else
									class="sd-action-bar sd-footer sd-clearfix d-flex justify-content-center"
									style="padding-bottom:0!important;padding-top:0!important;">
									<slot/>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>

		<div
			v-show="!useTitle" class="p-2 small"
			style="color: var(--sjs-general-forecolor-light, var(--foreground-light, #909090));">
			Survey is saved automatically when a question is answered or either 'Save &..' button is pressed.
		</div>
	</div>
</template>

<script lang="ts" setup>
	/** WCA Root Component */
	import { ref, onMounted, computed } from "vue";
	import "survey-core/defaultV2.min.css";
	StylesManager.applyTheme("defaultV2");
	import { StylesManager } from "survey-core";
	import { Model } from "survey-core";
	import { useSurveyStore } from "@/stores/survey";
	import { useAuthStore } from "@/stores/auth";
	import { useAlertStore } from "@/stores/alert";
	import UserService from "@/services/UserService";
	import AuthService from "@/services/AuthService";
	import { usePwaStore } from "@/stores/pwa";
	import { getResponseError } from "@/helpers/api";
	import axios from "@/plugins/axios";

	import * as SurveyCore from "survey-core";
	import noUiSlider from "nouislider";
	// @ts-ignore
	import { nouislider } from "surveyjs-widgets";
	import "nouislider/dist/nouislider.css";

	const props = defineProps<{
		// survey: Model;
		activeSurveyId: string;
		useTitle: boolean;
		class: string | null;
		isValid: boolean;
		isShowingPreview: boolean;
		title: string | undefined;
		description: string | undefined;
		isFirstPage: boolean | undefined;
		isLastPage: boolean | undefined;
		currentPageIsAll: boolean;
		completedHtml: string | null;
		isPreview: boolean;
	}>();

	let valid_at_summary = false;
	function goToSummary () {
		valid_at_summary = props.isValid;
		emit("go-summary");
	}

	const emit = defineEmits(["reinitialise-survey", "go-next", "go-back", "go-summary"]);
	function prevPage () {
		emit("go-back");
	}
	function nextPage () {
		emit("go-next");
	}
	// function restart() {
	// 	props.survey.cancelPreview(props.survey.pages[0]);
	// }
</script>

<style>

.noUi-origin{
	width:10%;
}
.sd-small-btn {
	/* max-width: 100px; */
	padding: calc(2*(var(--sjs-base-unit, var(--base-unit, 8px)))) calc(3*(var(--sjs-base-unit, var(--base-unit, 8px))));
}
.my-sd-root-modern {
	padding: 0px !important;
    --sd-mobile-width: 600px;
    --sd-timer-size: calc(18 * var(--sjs-base-unit, var(--base-unit, 8px)));
    width: 100%;
    font-family: var(--sjs-font-family, var(--font-family, var(--sjs-default-font-family)));
    background-color: var(--sjs-general-backcolor-dim, var(--background-dim, #f3f3f3));
}
</style>
